import { LanguageCode } from '@/Domain/Localization'
import { New, NewsRepository, NewsRepositoryError, NewFactory } from '@/Domain/News'
import { ApiClient } from '@/Domain/ApiClient'
import { AxiosNewsData } from './AxiosNewsData'

export class AxiosNewRepository implements NewsRepository {
  private _apiClient: ApiClient
  private _factory: NewFactory<AxiosNewsData>

  constructor (apiClient: ApiClient, factory: NewFactory<AxiosNewsData>) {
    this._apiClient = apiClient
    this._factory = factory
  }

  async fetchAll (languageCode: LanguageCode): Promise<New[]> {
    try {
      const url = '/sobree/api/news/' + languageCode
      const response = await this._apiClient.makeGetRequest(url, {})
      const news = response.data.data.map((current: AxiosNewsData) => {
        return this._factory.makeNew(current)
      })
      return news
    } catch (error) {
      return Promise.reject(new NewsRepositoryError(error.message))
    }
  }
}
